module.exports = __webpack_public_path__ + "static/media/2.70cf3d12.png";